import { TFunction } from "i18next";
import { ERole } from "../../../../utilities/EnumUtility";

/** 
 * Get the title of the section
 * @param userRole The user role
 * @returns the string of the title of the section
 */
export const getSectionTitleFrom = (t: TFunction, userRole: ERole) => {
    switch (userRole) {
        case ERole.HOST:
        case ERole.COHOST:
            return t('user.dashboard.listingsSectionTitle');
        case ERole.GUEST://no listing section for guest
        default:
            return '';
    }
}

/**
 * Get the message for the empty section
 * @param userRole The user role
 * @returns the string of the empty section message
 */
export const getEmptyContentMessageFrom = (t: TFunction, userRole: ERole) => {
    switch (userRole) {
        case ERole.HOST:
            return t('user.dashboard.listingsEmptyContent', { context: 'host' });
        case ERole.COHOST:
            return t('user.dashboard.listingsEmptyContent', { context: 'cohost' });
        case ERole.GUEST:
        default:
            return '';
    }
}
/**
 * Get the message for the empty section
 * @param userRole The user role
 * @returns the string of the empty section message
 */
export const getEmptyContentButtonLabelFrom = (t: TFunction, userRole: ERole) => {
    switch (userRole) {
        case ERole.HOST:
            return t('user.dashboard.listingsEmptyButton', { context: 'host' });
        case ERole.COHOST:
            return t('user.dashboard.listingsEmptyButton', { context: 'cohost' });
        case ERole.GUEST:
        default:
            return '';
    }
}